var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"row zero-height"}),(!_vm.hideNavigation)?_c('ProgressBar',{staticClass:"mt-0",attrs:{"groups":_vm.groups,"completeData":_vm.completeData,"answers":_vm.answers},on:{"update:groups":function($event){_vm.groups=$event},"update:answers":function($event){_vm.answers=$event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }